import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import axios from 'axios';
import { getFormulaire, updateFormulaire } from "../services/formulaireApi"; // Assurer que updateFormulaire existe et fonctionne
import { Col, Container, Row, Card, CardBody, Button, Form, Spinner } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import "../utils/style.css";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { FaChevronUp, FaChevronDown } from "react-icons/fa6";
import ReactQuill from "react-quill";
import groupAdd from '../../../assets/images/GroupAdd.png';

const Modification = () => {
  const history = useContext(HistoryContext);
  document.title = `Formulaires | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const { type } = useParams();
  console.log("Type récupéré de l'URL :", type);

  // Récupération des formulaires via useQuery
  const { data: formulaires, isLoading, isError, error } = useQuery("formulaires", getFormulaire);
  const [filteredFormulaires, setFilteredFormulaires] = useState([]);
  const [category, setCategory] = useState(null);

  // Déclaration des états pour stocker les valeurs des champs du formulaire
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [question, setQuestions] = useState("");
  const [selectedType, setSelectedType] = useState("");

  // Pré-remplir les champs avec les données du formulaire sélectionné
  useEffect(() => {
    if (formulaires && type) {
      // Filtrer les formulaires en fonction du type
      const filtered = formulaires.filter((formulaire) => formulaire.type === type);
      setFilteredFormulaires(filtered);
      if (filtered.length > 0) {
        const selectedFormulaire = filtered[0];
        setCategory(selectedFormulaire.category);
        setSelectedType(selectedFormulaire.type);
        setName(selectedFormulaire.name);
        setDescription(selectedFormulaire.description);
        setQuestions(selectedFormulaire.question);
      }
    }
  }, [formulaires, type]);

  if (isLoading) {
    return <Spinner color="primary" />;
  }

  if (isError) {
    return <Alert color="danger">{error?.message || "Une erreur est survenue."}</Alert>;
  }

  // Gestionnaire d'événements pour les inputs
  const handleNameChange = (e) => setName(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);
  const handleQuestionsChange = (content) => setQuestions(content);

  // Fonction pour gérer l'enregistrement
  const handleSave = async () => {
    try {
      const updatedData = {
        name,
        description,
        question,
        type: selectedType,  // Conserver le type inchangé
        category, // Conserver la catégorie inchangée
      };

      // Utilisation de la fonction updateFormulaire pour envoyer la mise à jour
      const response = await updateFormulaire(filteredFormulaires[0].id, updatedData);
      console.log("Formulaire mis à jour :", response);
      // Tu peux ici ajouter une redirection ou un message de succès
    } catch (error) {
      console.error("Erreur lors de la mise à jour du formulaire :", error);
    }
  };

  // État pour gérer l'ouverture ou la fermeture de chaque card
  const [openedCards, setOpenedCards] = useState({});
  useEffect(() => {
    if (filteredFormulaires.length > 0) {
      setOpenedCards((prevState) => ({
        ...prevState,
        [filteredFormulaires[0].id]: true, // Ouvre le premier card par défaut
      }));
    }
  }, [filteredFormulaires]);

  // Fonction pour toggler l'état d'une card spécifique
  const toggleCard = (id) => {
    setOpenedCards((prevState) => ({
      ...prevState,
      [id]: !prevState[id], // Inverse l'état de la card avec cet id
    }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            className="breadCrumb"
            page={`Page détail formulaire d'inspection > ${category ? ` ${category}` : ''} > ${type}`}
            history={history}
          />
          <Row className="justify-content-center">
            <Row className="form">Gérer votre formulaire d’inspection</Row>
            <Col className="typse">
              {type}
              <span><EditOutlined style={{ color: '#252525' }} /></span>
            </Col>
            <Row className="justify-content-center" style={{ marginLeft: '30px', marginRight: '30px' }}>
              {filteredFormulaires.map((formulaire) => (
                <Card style={{ border: '1.5px solid #D9D9D9', marginLeft: '30px', marginRight: '30px' }} key={formulaire.id}>
                  <CardBody>
                    <Row className="justify-content-center">
                      <Col md={10} className="titre">{formulaire.name}</Col>
                      <Col className="ml-auto">
                        <div className="ml-auto justify-content-end" style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: '8px',
                          width: "100%",
                          marginBottom: "16px"
                        }}>
                          <span className="pointAdd" onClick={() => toggleCard(formulaire.id)}>
                            <img src={groupAdd} alt="ajout" style={{ width: '25px' }} />
                          </span>
                        </div>
                      </Col>
                      <Col className="ml-auto">
                        <div className="ml-auto justify-content-end" style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: '8px',
                          width: "100%",
                          marginBottom: "16px"
                        }}>
                          <span className="pointDelete" onClick={() => toggleCard(formulaire.id)}>
                            <DeleteOutlined style={{ color: '#F22A2A' }} />
                          </span>
                        </div>
                      </Col>
                      <Col className="ml-auto justify-content-end" style={{
                        display: "flex",
                        alignItems: "center",
                        marginRight: '8px',
                        width: "100%",
                        marginBottom: "16px"
                      }}>
                        <span className="pointDetail" onClick={() => toggleCard(formulaire.id)}>
                          {openedCards[formulaire.id] ? (
                            <FaChevronUp size={10} color="dark" />
                          ) : (
                            <FaChevronDown size={10} color="dark" />
                          )}
                        </span>
                      </Col>
                    </Row>
                    {openedCards[formulaire.id] && (
                      <Form>
                        <Row className="justify-content-center">
                          <Col md={12}>
                            <div className="mb-3">
                              <label htmlFor="name" className="form-label labels">
                                Titre <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Veuillez renseigner le nom du formulaire à créer"
                                className="form-control values"
                                value={name || formulaire.name}
                                onChange={handleNameChange}
                                required
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="justify-content-center">
                          <Col md={12}>
                            <div className="mb-3">
                              <label htmlFor="description" className="form-label labels">
                                Instruction <span className="text-danger">*</span>
                              </label>
                              <textarea
                                id="description"
                                name="description"
                                className="form-control values"
                                value={description || formulaire.description}
                                onChange={handleDescriptionChange}
                                rows="4"
                                style={{ border: '1px solid #D9D9D9' }}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="justify-content-center">
                          <Col md={12}>
                            <label className="form-label labels">
                              Questions <span className="text-danger">*</span>
                            </label>
                            <ReactQuill
                              className="values"
                              value={question || formulaire.question}
                              onChange={handleQuestionsChange}
                              modules={{
                                toolbar: [
                                  ["bold", "italic", "underline"],
                                  ["blockquote"],
                                  [{ list: "ordered" }, { list: "bullet" }],
                                  ["link"],
                                  [{ align: [] }],
                                ],
                              }}
                              theme="snow"
                              placeholder="Écrivez votre question ici..."
                            />
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </CardBody>
                </Card>
              ))}
              <Row>
                <Col>
                  <Button
                    className="bordered-btn-lightN"
                    color="light"
                  >
                    Ajouter une question
                  </Button>
                  <Button
                    style={{ marginRight: '100px' }}
                    className="buttonAdd"
                    color="light"
                    onClick={handleSave} // On sauvegarde les modifications
                  >
                    Enregistrer
                  </Button>
                </Col>
              </Row>
            </Row>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Modification;
